import React from "react";
import { Container, Button } from "react-bootstrap";
import "./Hero.css";
import heroImage from "../../assets/hero-bg.jpg"; // Bild importieren
import '../../App.css'
const Hero = () => {
  return (
    <div className="hero-section" style={{ backgroundImage: `url(${heroImage})` }}>
      <Container className="hero-content">
        <div className="hero-box">
          <h1>Professionelle Stein- & Fassadenreinigung</h1>
          <p>Wir bringen Ihre Oberflächen zum Strahlen – nachhaltig & effektiv.</p>
          <Button variant="primary" size="lg">
            Jetzt Angebot anfordern
          </Button>
        </div>
      </Container>
    </div>
  );
};

export default Hero;
